import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '../hooks/form';

export const ErrorMessage = () => {
  const { store } = useFieldContext<string>();
  const { errors } = useStore(store, ({ meta }) => meta);

  return errors.map((error: string) => (
    <div
      key={error}
      className="text-brand-error relative left-3.5 px-1 text-sm"
    >
      {error}
    </div>
  ));
};
